// extracted by mini-css-extract-plugin
export default {"container":"not-found-profile_container__8iuDr","content":"not-found-profile_content__ykFgq"};